import { render, staticRenderFns } from "./WebinarUpcoming.vue?vue&type=template&id=21979814"
import script from "./WebinarUpcoming.vue?vue&type=script&lang=js"
export * from "./WebinarUpcoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports